import type { ReactElement, SVGProps } from "react";

/**
 * Z.ai (GLM) — the official Z.ai slash-Z mark, WHITE on the black Z.ai tile
 * (BRAND_TILE_BG.zhipu), matching the brand's white-on-black identity. GLM's
 * infra provider is now `fireworks`, but it keeps its own 'zhipu' DISPLAY brand
 * (label + mark), so this lives on the BRAND maps, not the provider maps.
 */
export function ZhipuLogo(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="#ffffff"
      aria-hidden
      {...props}
    >
      <path d="M12.105 2L9.927 4.953H.653L2.83 2h9.276zM23.254 19.048L21.078 22h-9.242l2.174-2.952h9.244zM24 2L9.264 22H0L14.736 2H24z" />
    </svg>
  );
}
